import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatRelative(value: string | null | undefined) {
  if (!value) return 'Not checked'
  const delta = Date.now() - new Date(value).getTime()
  const hours = Math.max(0, Math.floor(delta / 3_600_000))
  if (hours < 1) return 'This hour'
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  return `${days}d ago`
}

/** Compact form used in job rows: `11h`, `3d`, `not checked`. */
export function formatCheckedAge(value: string | null | undefined) {
  if (!value) return 'not checked'
  const hours = Math.max(0, Math.floor((Date.now() - new Date(value).getTime()) / 3_600_000))
  if (hours < 1) return '<1h'
  if (hours < 48) return `${hours}h`
  return `${Math.floor(hours / 24)}d`
}

export function formatSourceChecked(value: string | null | undefined) {
  const relative = formatRelative(value)
  return relative === 'Not checked' ? relative : `Checked against the company source ${relative.toLowerCase()}`
}

/**
 * Three states, in descending strength of claim. An agent review is never
 * reported as a human confirmation (see migration 0019).
 */
export function formatClassificationReview(job: { human_reviewed_at?: string | null; agent_reviewed_at?: string | null }) {
  if (job.human_reviewed_at) return `Confirmed by a person ${isoDay(job.human_reviewed_at)}`
  if (job.agent_reviewed_at) return `Reviewed by an agent ${isoDay(job.agent_reviewed_at)}`
  return 'Classified by rule set'
}

function isoDay(value: string) {
  return new Date(value).toISOString().slice(0, 10)
}

export function readJsonArray(value: string | string[] | null | undefined): string[] {
  if (Array.isArray(value)) return value
  if (!value) return []
  try {
    const parsed = JSON.parse(value)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}
